/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomComponentLibrariesLibraryIdGet200ResponseData } from './CustomComponentLibrariesLibraryIdGet200ResponseData';
import {
    CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSON,
    CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSONTyped,
    CustomComponentLibrariesLibraryIdGet200ResponseDataToJSON,
} from './CustomComponentLibrariesLibraryIdGet200ResponseData';

/**
 * The newly created Custom Component Library.
 * @export
 * @interface CustomComponentLibrariesPost200Response
 */
export interface CustomComponentLibrariesPost200Response {
    /**
     * API request succeeded
     * @type {boolean}
     * @memberof CustomComponentLibrariesPost200Response
     */
    success: boolean;
    /**
     * 
     * @type {CustomComponentLibrariesLibraryIdGet200ResponseData}
     * @memberof CustomComponentLibrariesPost200Response
     */
    data: CustomComponentLibrariesLibraryIdGet200ResponseData;
}

/**
 * Check if a given object implements the CustomComponentLibrariesPost200Response interface.
 */
export function instanceOfCustomComponentLibrariesPost200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CustomComponentLibrariesPost200ResponseFromJSON(json: any): CustomComponentLibrariesPost200Response {
    return CustomComponentLibrariesPost200ResponseFromJSONTyped(json, false);
}

export function CustomComponentLibrariesPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesPost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSON(json['data']),
    };
}

export function CustomComponentLibrariesPost200ResponseToJSON(value?: CustomComponentLibrariesPost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'data': CustomComponentLibrariesLibraryIdGet200ResponseDataToJSON(value.data),
    };
}

